module.exports = __webpack_public_path__ + "static/img/motorbike-red.c775d32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/motorbike-red.svg
// module id = gmQ5
// module chunks = 82